import React from "react";
import { Play, Radio } from "lucide-react";
import { optimizeImageUrl, HERO_PAGE_WIDTH } from "../lib/images";

export default function PlayerLoadingOverlay({
  loading,
  label = "Yükleniyor...",
  sublabel = "Lütfen bekleyin",
  coverImage,
  variant = "live",
}) {
  if (!loading) return null;

  const Icon = variant === "video" ? Play : Radio;
  const coverSrc = coverImage ? optimizeImageUrl(coverImage, HERO_PAGE_WIDTH) : null;

  return (
    <div className="absolute inset-0 z-10 flex flex-col items-center justify-center bg-[#0a0b16] overflow-hidden">
      {coverSrc && (
        <img
          src={coverSrc}
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-25 scale-105 blur-[2px]"
        />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-[#0a0b16] via-[#0a0b16]/80 to-[#0a0b16]/60" />
      <div className="relative z-10 flex flex-col items-center gap-4 px-6 text-center">
        <div className="relative">
          <div className="tv-player-spinner" />
          <div className="absolute inset-0 flex items-center justify-center">
            <Icon size={18} className="text-[var(--tv-purple-bright)]" />
          </div>
        </div>
        <div>
          <p className="text-white font-semibold text-sm">{label}</p>
          <p className="text-[var(--tv-muted)] text-xs mt-1">{sublabel}</p>
        </div>
      </div>
    </div>
  );
}
